export const INFO_MESSAGES = {
  en: {
    chatEnded: 'Chat ended',
    chatEndedConfirm: 'Are you sure to close the chat?',
    liveChatEnded: 'Chat ended',
    liveChatEndedDueToConnectionLost: 'Connection lost',
    chatAssistant: 'Chat Assistant',
    typeAMessage: 'Type a message...',
    messageQueuedCount: 'Queued',
    messageQueuedPlaceholder: 'Add a follow-up',
    unreadMessages: 'Unread messages',
    poorConnectionWarning: 'Your internet connection appears to be poor. Check your connection quality to avoid problems.',
    liveChatStarted: 'LIVE CHAT',
    waitingForAgent: 'WAITING FOR AN AGENT',
    inactivityAutoCloseLabel: 'Auto-close',
    inactivityAutoCloseTooltip: 'When enabled, the system warns the customer after inactivity and closes the chat if they do not reply.',
    inactivityAutoCloseEnabled: 'Auto-close enabled for this chat.',
    inactivityAutoCloseDisabled: 'Auto-close disabled for this chat.',
    inactivityAutoCloseOn: 'On',
    inactivityAutoCloseOff: 'Off',
    endSessionTooltip: 'End Session',
    closeSessionTooltip: 'Close Session',
    transferToPhoneTooltip: 'Transfer to phone',
    sessionActionsMenu: 'Session actions',
  },
  tr: {
    chatEnded: 'Chat sonlandırıldı',
    chatEndedConfirm: 'Görüşmeyi sonlandırmak istediğinize emin misiniz?',
    liveChatEnded: 'Chat sonlandırıldı',
    liveChatEndedDueToConnectionLost: 'Bağlantı kesildi',
    chatAssistant: 'Sohbet Asistanı',
    typeAMessage: 'Mesaj yazın...',
    messageQueuedCount: 'Sırada',
    messageQueuedPlaceholder: 'Takip mesajı ekle',
    unreadMessages: 'Okunmamış mesajlar',
    poorConnectionWarning: 'İnternet bağlantınız kötü görünüyor, problem yaşamamak için bağlantınızın kalitesini kontrol edin.',
    liveChatStarted: 'CANLI SOHBET',
    waitingForAgent: 'BİR TEMSİLCİ BEKLENİYOR',
    inactivityAutoCloseLabel: 'Otomatik kapanma',
    inactivityAutoCloseTooltip: 'Açıkken müşteri yanıt vermezse sistem uyarı gönderir; yanıt gelmezse görüşmeyi kapatır.',
    inactivityAutoCloseEnabled: 'Bu görüşme için otomatik kapanma açıldı.',
    inactivityAutoCloseDisabled: 'Bu görüşme için otomatik kapanma kapatıldı.',
    inactivityAutoCloseOn: 'Açık',
    inactivityAutoCloseOff: 'Kapalı',
    endSessionTooltip: 'Görüşmeyi Sonlandır',
    closeSessionTooltip: 'Görüşmeyi Kapat',
    transferToPhoneTooltip: 'Telefona transfer et',
    sessionActionsMenu: 'Görüşme işlemleri',
  },
  es: {
    chatEnded: 'Chat finalizado',
    chatEndedConfirm: '¿Estás seguro de cerrar el chat?',
    liveChatEnded: 'Chat finalizado',
    liveChatEndedDueToConnectionLost: 'Conexión perdida',
    chatAssistant: 'Asistente del Chat',
    typeAMessage: 'Escribe un mensaje...',
    messageQueuedCount: 'En cola',
    messageQueuedPlaceholder: 'Añadir un seguimiento',
    unreadMessages: 'Mensajes no leídos',
    poorConnectionWarning: 'Su conexión a internet parece deficiente. Compruebe la calidad de su conexión para evitar problemas.',
    liveChatStarted: 'CHAT EN VIVO',
    waitingForAgent: 'ESPERANDO A UN AGENTE',
    inactivityAutoCloseLabel: 'Cierre automático',
    inactivityAutoCloseTooltip: 'Si está activado, el sistema avisa al cliente tras la inactividad y cierra el chat si no responde.',
    inactivityAutoCloseEnabled: 'Cierre automático activado para este chat.',
    inactivityAutoCloseDisabled: 'Cierre automático desactivado para este chat.',
    inactivityAutoCloseOn: 'Activado',
    inactivityAutoCloseOff: 'Desactivado',
    endSessionTooltip: 'Finalizar sesión',
    closeSessionTooltip: 'Cerrar sesión',
    transferToPhoneTooltip: 'Transferir a teléfono',
    sessionActionsMenu: 'Acciones de la sesión',
  }
} as const;